import React, { useState } from 'react';
import {
  Card,
  Select,
  Form,
  Input,
  DatePicker,
  Button,
  Row,
  Col,
  Collapse,
  Typography,
  Space,
  Divider,
  Switch,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useRef } from 'react';
import { useAuth } from '../../hooks/useAuth';
import individualTraderService from '../../services/IndividualTraderService';
import WorkflowAccOpeningService from '../../services/WorkflowAccOpeningService';

const { Panel } = Collapse;
const { Title } = Typography;

export default function PrepareIndividualTrader() {
  // Form control
  const [form] = Form.useForm();
  const { showNotification } = useAuth();
  const [requiredMark, setRequiredMarkType] = useState('');
  const [loading, setLoading] = useState(false);
  const onRequiredTypeChange = ({ requiredMarkValue }) => {
    setRequiredMarkType(requiredMarkValue);
  };
  const occupationInputRef = useRef(null);
  const [occupation, setOccupation] = useState('');

  const [occupationItems, setOccupationItems] = useState([
    'Business',
    'Private Sector',
    'Public Sector',
    'Government Services',
    'Famer',
    'Student',
    'Professional',
    'Housewife',
    'Retired',
    'Salary Employee',
  ]);

  const nationalityTypeOptions = ['MYANMAR', 'OTHER'];
  const maritalStatusOptions = ['Married', 'Single', 'Widow/Widower', 'Divorce', 'Not Applicable'];
  const annualIncomeRangeOptions = [
    'Below & Equal to MMK 2,000,000',
    'From MMK  2,000,001 to MMK 5,000,000',
    'From MMK  5,000,001 to MMK 10,000,000',
    'From MMK  10,000,001 to MMK 20,000,000',
    'From MMK  20,000,001 to MMK 30,000,000',
    'Above MMK 30,000,000',
  ];
  const netWorthOptions = [
    'Below & Equal to MMK 10,000,000',
    'From MMK 10,000,001 to MMK 50,000,000',
    'From MMK 50,000,001 to MMK 100,000,000',
    'Above MMK 100,000,000',
  ];
  const sourceOfFundOptions = ['Employment', 'Self-employed', 'Inheritance', 'Others'];
  const identityTypeOptions = ['NRC', 'Passport'];
  const nextOfKinTypeOptions = ['FATHER', 'MOTHER', 'SPOUSE', 'FRIEND', 'RELATIVE'];

  const navigate = useNavigate();

  const addOccupation = e => {
    e.preventDefault();
    setOccupationItems([...occupationItems, occupation]);
    setOccupation('');
    setTimeout(() => {
      occupationInputRef.current?.focus();
    }, 0);
  };

  const onFinish = async formValues => {
    const payload = {
      agreementDate: new Date(formValues.agreementDate.valueOf()),
      exchangeSegment: formValues.exchangeSegment,
      primaryEmail: formValues.primaryEmail,
      individualProfile: {
        identityType: formValues.traderIdentityType,
        identityValue: formValues.traderIdNumber,
        nameOnIdentity: formValues.traderNameOnID,
        firstName: formValues.traderFirstName,
        lastName: formValues.traderLastName,
        middleName: formValues.traderMiddleName ? formValues.traderMiddleName : '',
        nationalityType: formValues.traderNationalityType,
        dateOfBirth: new Date(formValues.traderDOB.valueOf()),
        maritalStatus: formValues.traderMaritialStatus,
        occupation: formValues.traderOccupation,
        politicalAffiliation: formValues.traderPoliticalAffiliation,
        annualIncomeRange: formValues.traderAnnualIncomeRange,
        annualIncomeOnDate: new Date(formValues.traderAnnualIncomeOnDate.valueOf()),
        netWorth: formValues.traderNetWorth,
        netWorthOnDate: new Date(formValues.traderNetWorthOnDate.valueOf()),
        sourceOfFund: formValues.traderSourceOfFund,
        // nextOfKinIdentityType: formValues.traderNextOfKinIdType,
        // nextOfKinIdentityValue: formValues.traderNextOfKinIdNumber,
        // nextOfKinType: formValues.traderNextOfKinType,
        // nextOfKinName: formValues.traderNextOfKinName,
        inPersonVerification: formValues.traderInPersonVerification,
      },
    };
    console.log(payload);
    setLoading(true);
    const result = await WorkflowAccOpeningService.prepareIndividualAcc(payload);
    setLoading(false);
    console.log(result);

    if (result.success) {
      showNotification('success', 'Successfully submitted');
      navigate(`/individual/fill/${result.data.workflowId}`);
    } else {
      showNotification('error', result.message);
    }
  };

  const onOccupationChange = event => {
    setOccupation(event.target.value);
  };

  return (
    <>
      <Title level={4} style={{ marginTop: 0, marginBottom: '2rem' }}>
        Individual Account Opening - Submission
      </Title>
      <Card title="Step 1 of 2: Peparation" style={{ background: '#fcfcfc' }}>
        <Form
          onFinish={onFinish}
          form={form}
          labelCol={{
            span: 8,
            lg: {
              span: 14,
            },
            xl: {
              span: 12,
            },
          }}
          layout="horizontal"
          size={'medium'}
          // required field related
          initialValues={{
            requiredMarkValue: requiredMark,
            exchangeSegment: 'YSX',
            clientType: 'LOCAL_INDIVIDUAL',
            traderIdentityType: 'NRIC',
            traderMaritialStatus: 'Single',
            traderNationalityType: 'MYANMAR',
            // traderNextOfKinIdType: 'NRIC',
          }}
          onValuesChange={onRequiredTypeChange}
          requiredMark={requiredMark}
        >
          <Collapse defaultActiveKey={['1']} bordered={false} expandIconPosition={'end'} accordion>
            {/* Application Information */}
            <Panel header={'Application Information'} key={'1'}>
              <Row gutter={16} style={{ marginTop: '2rem' }}>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <Form.Item label="Exchange Segment" name={'exchangeSegment'}>
                    <Select>
                      <Select.Option value="YSX">YSX</Select.Option>
                    </Select>
                  </Form.Item>
                  {/* <Form.Item label="Application No" name={'applicationNumber'}>
                    <Input placeholder="Eg. APN00001234" />
                  </Form.Item> */}
                  <Form.Item
                    label="Primary Email"
                    name={'primaryEmail'}
                    rules={[
                      {
                        required: true,
                        message: 'Please do not leave blank',
                        type: 'email',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <Form.Item
                    label="Agreement Date"
                    name={'agreementDate'}
                    rules={[
                      {
                        required: true,
                        message: 'Please select agreement date',
                      },
                    ]}
                  >
                    <DatePicker
                      style={{
                        width: '100%',
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>

            {/* Trader Profile */}
            <Panel header={'Trader Profile'} key={'2'}>
              <Row gutter={16} style={{ marginTop: '2rem' }}>
                <Col
                  xs={{
                    span: 24,
                    // order: 2,
                  }}
                  sm={24}
                  md={24}
                  lg={{
                    span: 12,
                    // order: 1,
                  }}
                >
                  <Form.Item
                    label="Identity Type"
                    name={'traderIdentityType'}
                    rules={[
                      {
                        required: true,
                        message: 'Please select identity type',
                      },
                    ]}
                  >
                    <Select>
                      <Select.Option value="NRIC">NRIC</Select.Option>
                      <Select.Option value="PASSPORT">PASSPORT</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Nationality Type"
                    name={'traderNationalityType'}
                    rules={[
                      {
                        required: true,
                        message: 'Please select nationality type',
                      },
                    ]}
                  >
                    <Select>
                      <Select.Option value="MYANMAR">MYANMAR</Select.Option>
                      <Select.Option value="OTHER">OTHER</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Identity No"
                    name={'traderIdNumber'}
                    rules={[
                      {
                        required: true,
                        message: 'Please do not leave blank',
                      },
                    ]}
                  >
                    <Input placeholder="12/Tamana(N)123456" />
                  </Form.Item>
                  <Form.Item
                    label="Name on Identity"
                    name={'traderNameOnID'}
                    rules={[
                      {
                        required: true,
                        message: 'Please do not leave blank',
                      },
                    ]}
                  >
                    <Input placeholder="Enter the name" />
                  </Form.Item>
                  <Form.Item
                    label="First Name"
                    name={'traderFirstName'}
                    rules={[
                      {
                        required: true,
                        message: 'Please do not leave blank',
                      },
                    ]}
                  >
                    <Input placeholder="Enter the first name" />
                  </Form.Item>
                  <Form.Item label="Middle Name" name={'traderMiddleName'}>
                    <Input placeholder="Enter the middle name (Optional)" />
                  </Form.Item>
                  <Form.Item
                    label="Last Name"
                    name={'traderLastName'}
                    rules={[
                      {
                        required: true,
                        message: 'Please do not leave blank',
                      },
                    ]}
                  >
                    <Input placeholder="Enter the last name" />
                  </Form.Item>
                  <Form.Item
                    label="Date of Birth"
                    name={'traderDOB'}
                    rules={[
                      {
                        required: true,
                        message: 'Please do not leave blank',
                      },
                    ]}
                  >
                    <DatePicker
                      style={{
                        width: '100%',
                      }}
                    />
                  </Form.Item>
                  
                </Col>
                <Col
                  xs={{
                    span: 24,
                    // order: 1,
                  }}
                  sm={24}
                  md={24}
                  lg={{
                    span: 12,
                    // order: 2,
                  }}
                >
                  <Form.Item
                    label="Maritial Status"
                    name={'traderMaritialStatus'}
                    rules={[
                      {
                        required: true,
                        message: 'Please select maritial status',
                      },
                    ]}
                  >
                    <Select
                      options={maritalStatusOptions.map(item => ({
                        label: item,
                        value: item,
                      }))}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Occupation"
                    name={'traderOccupation'}
                    rules={[
                      {
                        required: true,
                        message: 'Please select occupation',
                      },
                    ]}
                  >
                    <Select
                      // style={{
                      //   width: 300,
                      // }}
                      dropdownRender={menu => (
                        <>
                          {menu}
                          <Divider
                            style={{
                              margin: '8px 0',
                            }}
                          />
                          <Space
                            style={{
                              padding: '0 8px 4px',
                            }}
                          >
                            <Input
                              placeholder="Others"
                              ref={occupationInputRef}
                              value={occupation}
                              onChange={onOccupationChange}
                            />
                            <Button type="text" icon={<PlusOutlined />} onClick={addOccupation}>
                              Add item
                            </Button>
                          </Space>
                        </>
                      )}
                      options={occupationItems.map(item => ({
                        label: item,
                        value: item,
                      }))}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Political Affiliation"
                    name={'traderPoliticalAffiliation'}
                    rules={[
                      {
                        required: true,
                        message: 'Please do not leave blank',
                      },
                    ]}
                  >
                    <Input placeholder="" />
                  </Form.Item>
                  <Form.Item
                    label="Annual Income Range"
                    name={'traderAnnualIncomeRange'}
                    rules={[
                      {
                        required: true,
                        message: 'Please select income range',
                      },
                    ]}
                  >
                    <Select
                      options={annualIncomeRangeOptions.map(item => ({
                        label: item,
                        value: item,
                      }))}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Annual Income On Date"
                    name={'traderAnnualIncomeOnDate'}
                    rules={[
                      {
                        required: true,
                        message: 'Please do not leave blank',
                      },
                    ]}
                  >
                    <DatePicker
                      style={{
                        width: '100%',
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Net Worth"
                    name={'traderNetWorth'}
                    rules={[
                      {
                        required: true,
                        message: 'Please select net worth',
                      },
                    ]}
                  >
                    <Select
                      options={netWorthOptions.map(item => ({
                        label: item,
                        value: item,
                      }))}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Net Worth On Date"
                    name={'traderNetWorthOnDate'}
                    rules={[
                      {
                        required: true,
                        message: 'Please do not leave blank',
                      },
                    ]}
                  >
                    <DatePicker
                      style={{
                        width: '100%',
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Source Of Fund"
                    name={'traderSourceOfFund'}
                    rules={[
                      {
                        required: true,
                        message: 'Please select source of fund',
                      },
                    ]}
                  >
                    <Select
                      options={sourceOfFundOptions.map(item => ({
                        label: item,
                        value: item,
                      }))}
                    />
                  </Form.Item>
                  {/* <Form.Item label="Next of Kin ID Type" name={'traderNextOfKinIdType'}>
                    <Select>
                      <Select.Option value="NRIC">NRIC</Select.Option>
                      <Select.Option value="PASSPORT">PASSPORT</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Next of Kin ID No"
                    name={'traderNextOfKinIdNumber'}
                    rules={[
                      {
                        required: true,
                        message: 'Please do not leave blank',
                      },
                    ]}
                  >
                    <Input placeholder="12/Tamana(N)123456" />
                  </Form.Item>
                  <Form.Item
                    label="Next of Kin Type"
                    name={'traderNextOfKinType'}
                    rules={[
                      {
                        required: true,
                        message: 'Please do not leave blank',
                      },
                    ]}
                  >
                    <Select
                      options={nextOfKinTypeOptions.map(item => ({
                        label: item,
                        value: item,
                      }))}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Next of Kin Name"
                    name={'traderNextOfKinName'}
                    rules={[
                      {
                        required: true,
                        message: 'Please do not leave blank',
                      },
                    ]}
                  >
                    <Input placeholder="Enter the kin name" />
                  </Form.Item> */}
                  <Form.Item
                    label="Status (In Person Verification)"
                    name="traderInPersonVerification"
                    valuePropName="checked"
                    initialValue={false}
                  >
                    <Switch checkedChildren="Yes" unCheckedChildren="No" />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>

          <Space
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItem: 'center',
              marginTop: '2rem',
            }}
          >
            <Button type="default" size={'large'} onClick={() => navigate('/')}>
              <ArrowLeftOutlined /> Back
            </Button>
            <Button type="primary" key="submit" htmlType="submit" size={'large'} loading={loading}>
              Prepare
            </Button>
          </Space>
        </Form>
      </Card>
    </>
  );
}
